import { Link } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full bg-background-50 py-3">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <ol className="flex items-center gap-1.5 text-xs text-foreground-500 flex-wrap">
          <li>
            <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">
              首页
            </Link>
          </li>
          {items.map((item, index) => (
            <li key={index} className="flex items-center gap-1.5">
              <span className="text-foreground-400">/</span>
              {item.path ? (
                <Link to={item.path} className="hover:text-primary-500 transition-colors cursor-pointer">
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-700 font-medium">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}